export default {
  pageTitle: 'Factory Tour',
  metaDescription: 'Daftar Factory Tour PT Tokki Engineering and Fabrication (TEF) dan kunjungi langsung fasilitas produksi bejana tekan dan penukar panas kami di Cikarang.',
  hero: {
    title: 'Factory Tour',
    subtitle: 'Kunjungi langsung fasilitas produksi dan proses fabrikasi PT TEF',
  },
  intro: {
    heading: 'Kunjungan ke Pabrik TEF',
    description: 'PT Tokki Engineering and Fabrication membuka kesempatan bagi pelajar, mahasiswa, instansi, dan mitra bisnis untuk melihat langsung proses produksi bejana tekan, penukar panas, dan fabrikasi khusus kami. Daftarkan kunjungan Anda melalui formulir di bawah ini.',
  },
  highlights: {
    schedule: { title: 'Jadwal Kunjungan', desc: 'Senin - Jumat, sesuai jam operasional kantor' },
    advanceBooking: { title: 'Pendaftaran Awal', desc: 'Pengajuan minimal 1 bulan sebelum tanggal kunjungan' },
    groupSize: { title: 'Jumlah Peserta', desc: 'Kunjungan kelompok maksimal 40 orang per sesi' },
    freeOfCharge: { title: 'Perlengkapan Keselamatan', desc: 'Peserta wajib membawa sepatu safety dan helm safety sendiri' },
  },
  terms: {
    heading: 'Syarat & Ketentuan',
    items: [
      'Pendaftaran dilakukan minimal 7 hari kerja sebelum tanggal kunjungan yang diinginkan.',
      'Peserta wajib mengenakan pakaian dan sepatu tertutup selama berada di area produksi demi keselamatan.',
      'Tim TEF akan menghubungi Anda melalui email/telepon untuk konfirmasi jadwal dan detail kunjungan.',
      'PT TEF berhak menyesuaikan atau menjadwalkan ulang kunjungan sesuai dengan kondisi operasional pabrik.',
      'Dilarang membawa alat perekam/kamera ke area tertentu tanpa izin tertulis dari pihak TEF.',
    ],
  },
  form: {
    heading: 'Formulir Pendaftaran',
    subheading: 'Lengkapi data di bawah ini untuk mengajukan kunjungan factory tour',
    fullName: 'Nama Lengkap',
    institutionName: 'Nama Instansi / Perusahaan',
    email: 'Email',
    phoneNumber: 'Nomor Telepon',
    participants: 'Jumlah Peserta',
    preferredDate: 'Tanggal Kunjungan yang Diinginkan',
    purpose: 'Tujuan / Catatan Tambahan',
    purposePlaceholder: 'Ceritakan tujuan kunjungan Anda...',
    submit: 'Ajukan Kunjungan',
    pleaseWait: 'Mohon Tunggu...',
    successMessage: 'Pendaftaran factory tour berhasil dikirim. Tim kami akan segera menghubungi Anda.',
    errorMessage: 'Pendaftaran gagal dikirim. Silakan coba lagi.',
    requiredNotice: 'Semua kolom bertanda * wajib diisi',
  },
};
